/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SignatureRequestStatus = {
    Pending: 'PENDING',
    Signed: 'SIGNED'
} as const;
export type SignatureRequestStatus = typeof SignatureRequestStatus[keyof typeof SignatureRequestStatus];


export function instanceOfSignatureRequestStatus(value: any): boolean {
    for (const key in SignatureRequestStatus) {
        if (Object.prototype.hasOwnProperty.call(SignatureRequestStatus, key)) {
            if (SignatureRequestStatus[key as keyof typeof SignatureRequestStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SignatureRequestStatusFromJSON(json: any): SignatureRequestStatus {
    return SignatureRequestStatusFromJSONTyped(json, false);
}

export function SignatureRequestStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignatureRequestStatus {
    return json as SignatureRequestStatus;
}

export function SignatureRequestStatusToJSON(value?: SignatureRequestStatus | null): any {
    return value as any;
}

export function SignatureRequestStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SignatureRequestStatus {
    return value as SignatureRequestStatus;
}

